/** Retire current menu font glyphs, including HTML cached by the old drawer.
 * Server-rendered SVG templates are cloned only for exact known icon names.
 * Unknown legacy/editor icons retain the original on-demand font fallback. */
(() => {
  const source = document.currentScript?.dataset.iconCss;
  if (!source) return;
  const selector = '.las, .lar, .lab, i[class^="la-"], i[class*=" la-"]';
  const glyphs = new Map(Array.from(document.querySelectorAll('template[data-etr-menu-glyph]'), t => [t.dataset.etrMenuGlyph, t]));
  let loaded = false, scheduled = false;
  function scan() {
    scheduled = false;
    document.querySelectorAll(selector).forEach(node => {
      const key = Array.from(node.classList).find(name => glyphs.has(name));
      if (key && node.tagName === 'I' && !node.textContent.trim()) node.replaceWith(glyphs.get(key).content.cloneNode(true));
    });
    if (!loaded && document.querySelector(selector)) {
      loaded = true;
      const link = document.createElement('link'); link.rel = 'stylesheet'; link.href = source;
      document.head.append(link);
    }
  }
  const observer = new MutationObserver(records => {
    if (!scheduled && records.some(r => Array.from(r.addedNodes).some(n => n.nodeType === 1 && (n.matches(selector) || n.querySelector(selector))))) {
      scheduled = true; requestAnimationFrame(scan);
    }
  });
  scan(); observer.observe(document.body, { childList: true, subtree: true });
})();
